import React from "react";
import ParticleBlob from "./ParticleBlob";
import { Section } from "./primitives";

export default function StatementSection({ data }) {
  return (
    <Section bg={data.bg} pt={150} pb={150} style={{ overflow: "hidden" }}>
      <div
        style={{
          minHeight: "58vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          position: "relative",
        }}
      >
        <div
          className="anim-float-slow"
          style={{ marginBottom: 48, filter: "blur(0.2px)" }}
        >
          <ParticleBlob
            size={340}
            density={105}
            blobs={data.blobs}
          />
        </div>
        <h2
          className="font-type reveal"
          style={{
            margin: 0,
            maxWidth: 900,
            fontSize: "clamp(30px, 4.6vw, 62px)",
            fontWeight: 700,
            lineHeight: 1.06,
            letterSpacing: "-1px",
          }}
        >
          {data.heading}
        </h2>
        <p
          className="reveal d1"
          style={{
            margin: "18px 0 0",
            fontSize: "clamp(15px, 1.5vw, 19px)",
            color: "var(--ink-soft)",
          }}
        >
          {data.sub}
        </p>
      </div>
    </Section>
  );
}
